import React from 'react';
import { Button } from './Button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';
import { Download, FileText, FileType, ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

interface ExportDropdownProps {
  onExportTxt: () => void | Promise<void>;
  onExportPdf: () => void | Promise<void>;
  disabled?: boolean;
  loading?: boolean;
  variant?: 'default' | 'outline' | 'ghost';
  size?: 'sm' | 'default' | 'lg' | 'icon';
  className?: string;
  showText?: boolean;
  title?: string;
}

export const ExportDropdown: React.FC<ExportDropdownProps> = ({
  onExportTxt,
  onExportPdf,
  disabled = false,
  loading = false,
  variant = 'outline',
  size = 'sm',
  className,
  showText = true,
  title = 'Export',
}) => {
  const handleExportTxt = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await onExportTxt();
  };

  const handleExportPdf = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    await onExportPdf();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size={size}
          disabled={disabled || loading}
          className={cn('flex items-center gap-2', className)}
          title={title}
        >
          <Download className="w-4 h-4" />
          {showText && <span className="hidden sm:!inline">Export</span>}
          <ChevronDown className="w-3 h-3" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        <DropdownMenuItem
          onClick={handleExportTxt}
          disabled={disabled || loading}
          className="cursor-pointer flex items-center gap-2"
        >
          <FileText className="w-4 h-4" />
          <span>Export as TXT</span>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={handleExportPdf}
          disabled={disabled || loading}
          className="cursor-pointer flex items-center gap-2"
        >
          <FileType className="w-4 h-4" />
          <span>Export as PDF</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportDropdown;
